import { Expose, Type } from 'class-transformer';
import { DropdownModel } from '@shared/models/dropdown-model.model';
import { Customer } from './customer.model';
import { LocationModel } from './location.model';

export class CustomerWithLocation extends DropdownModel {
  @Type(() => Customer)
  @Expose()
  customer: Customer = new Customer();

  @Type(() => LocationModel)
  @Expose()
  location?: LocationModel = new LocationModel();

  constructor() {
    super();
  }

  get contactName(): string {
    return this.customer.contactFirstName + ' ' + this.customer.contactLastName;
  }

  get dropDownDisplayName(): string {
    return this.customer.title;
  }
  get dropDownValue(): CustomerWithLocation {
    return this;
  }
}
